// Sdílená data Ekonomiky (220): odznaky v obalu (naskladnění, duplicity), fronta
// naskladnění a panel duplicit čtou TYTÉŽ react-query klíče, takže obal i záložka
// nevolají stejný endpoint dvakrát. staleTime 0 = při každém připojení čerstvá data
// (jako dřív), souběžná připojení ale sdílí jeden požadavek.
import { api } from "@/lib/api";

const get = (url) => () => api.get(url).then((r) => r.data);

export const ECO_BADGES = "eco-badges";
export const stockQueueQuery = { queryKey: [ECO_BADGES, "stock-queue"], queryFn: get("/documents/stock-queue"), staleTime: 0, retry: false };
export const dupPairsQuery = { queryKey: [ECO_BADGES, "dup-pairs"], queryFn: get("/documents/duplicates"), staleTime: 0, retry: false };
// Lehký počet duplicit drží jen odznak v obalu: načte se při vstupu do Ekonomiky (jako dřív)
// a po změně dokladu (invalidace); přepnutí záložek ho znovu nevolá.
export const dupCountQuery = { queryKey: [ECO_BADGES, "dup-count"], queryFn: get("/documents/duplicates/count"),
  staleTime: 60_000, refetchOnMount: "always", retry: false };

// Po změně dokladu: přenačte jen to, co je právě na obrazovce. cancelRefetch: false —
// když už požadavek běží (obal i záložka reagují na stejnou událost), nový se nespustí.
export function refreshEcoBadges(qc) {
  return qc.invalidateQueries({ queryKey: [ECO_BADGES] }, { cancelRefetch: false });
}

// Nejčerstvější z víc dotazů, které nesou stejné číslo (počet duplicit z plného
// seznamu na Dokladech, jinak z lehkého počtu) — odznak při přepnutí neblikne na nulu.
export function freshest(...queries) {
  return queries.filter((q) => q && q.data).sort((a, b) => b.dataUpdatedAt - a.dataUpdatedAt)[0]?.data;
}
